import React from "react";
import { Download, FileSpreadsheet, FileText, FileType } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface DataExportButtonProps {
  onExport: (format: "pdf" | "excel" | "csv") => void;
  label?: string;
  variant?: "contained" | "outlined";
}

const DataExportButton: React.FC<DataExportButtonProps> = ({
  onExport,
  label = "Export",
  variant = "outlined",
}) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button variant={variant === "contained" ? "default" : "outline"} size="sm">
        <Download />
        {label}
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="min-w-48">
      <DropdownMenuLabel>Export as</DropdownMenuLabel>
      <DropdownMenuItem onSelect={() => onExport("pdf")}>
        <FileText />
        PDF document
      </DropdownMenuItem>
      <DropdownMenuItem onSelect={() => onExport("excel")}>
        <FileSpreadsheet />
        Excel spreadsheet
      </DropdownMenuItem>
      <DropdownMenuItem onSelect={() => onExport("csv")}>
        <FileType />
        CSV file
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);

export default DataExportButton;
